var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play-layout"},[_c('aside',{staticClass:"play-sider"}),_c('main',{staticClass:"play-main"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }